import { combineReducers } from "redux";

import genericFormData from './GenericFormDataReducer'
import mplFormData from './MPL/AddMPLFormData'
import cmFormData from './AddCMFormData'

export default combineReducers({
    genericFormData,
    mplFormData,
    cmFormData
});